module.exports = __webpack_public_path__ + "static/media/rozet.bb68f754.png";